import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingService } from '@core/services/loading/loading-api';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';
import { asyncScheduler } from 'rxjs';
import { distinctUntilChanged, observeOn } from 'rxjs/operators';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.html',
  styleUrls: ['./spinner.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, MaterialsModule],
})
export class SpinnerComponent {
  // Defer emissions by one microtask so initial bootstrap/loading flips do not
  // change the @if condition during the same change-detection pass.
  isLoading$ = this.loadingService.isLoading$.pipe(
    observeOn(asyncScheduler),
    distinctUntilChanged()
  );

  constructor(private loadingService: LoadingService) { }
}
